
import Vue from 'vue'

export default Vue.extend({
  props: ['deleteEntity', 'deleting', 'closeDeleteDialog'],
})
